import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill';

import React from 'react';
import ReactDOM from 'react-dom/client';
import ApplicationStateful from './components/theme/ApplicationStateful';
import slovene from './translations/slovene';

import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { BrowserRouter } from 'react-router-dom';

import './scss/main.scss';

i18n
	.use(initReactI18next)
	.init({
		resources: {
			sl: { translation: slovene },
		},
		lng: 'sl',
	})
	.then();

ReactDOM.createRoot(document.getElementById('app')).render(
	<BrowserRouter>
		<ApplicationStateful />
	</BrowserRouter>
);
